import React, { useState, type FC } from 'react';
import RegisterLayout from '@/registration/component/Register/Layout';
import BaseTransitionSlideLeft from '@/base/Transition/SlideLeft';
import BaseShoppingCart from '@/registration/component/Register/GroupShoppingCart';
import LayoutFooter from '@/registration/component/Register/Layout/Footer';
import { UiButton, UiHStack, UiIconCaretLeft, UiIconCaretRight, UiStack } from '@/lib/ui';
import { useRegisterRoute } from '@/registration/hook/useRegisterRoute';
import QueryContainer from '@/base/QueryContainer/QueryContainer';
import { useRegisterGroupSteps } from '@/registration/hook/useRegisterGroupSteps';
import GroupHeader from '@/registration/component/Register/Layout/GroupHeader';
import { useGroupCartQuery } from '@/registration/hook/useGroupCartQuery';
import InfoBox from '@/registration/component/InfoBox';
import RemindToAddTickets from '@/registration/component/Register/RemindToAddTickets';
import { useMutation } from '@tanstack/react-query';
import { ApiResponseSingle } from '@/api/tenantClient';
import { Order, processFreeOrder, ProcessFreeOrderRequest } from '@/api/registration/order';
import { generatePageUrl } from '@/app/pages';
import { useTenantApi } from '@/account/hook/useTenantApi';
import { useNavigate } from 'react-router-dom';
import { isCurrencyValueZero } from '@/registration/utils/currencyUtils';
import BaseThemeButton from '@/base/ThemeButton';

const ShoppingCart: FC = () => {
  const { toNextStep, toPreviousStep } = useRegisterGroupSteps();
  const { eventId, tenantCode } = useRegisterRoute();
  const cartQuery = useGroupCartQuery(eventId);
  const { createTenantApiRequest } = useTenantApi();

  const [errors, setErrors] = useState<string[]>([]);
  const navigate = useNavigate();

  const { mutate: processFreeOrderMutate, isLoading: isProcessFreeOrderLoading } = useMutation<ApiResponseSingle<Order>, Error, ProcessFreeOrderRequest>({
    mutationFn: async (preparePaymentData: ProcessFreeOrderRequest) => {
      return await processFreeOrder(createTenantApiRequest)(preparePaymentData);
    },
    onSuccess: (result) => {
      if (result.errors && result.errors.length > 0) {
        setErrors(result.errors);
      } else {
        navigate(generatePageUrl('RegistrationRegisterGroupConfirmation', { tenantCode, eventId }, { orderHash: result.item.secureHash }));
      }
    },
    onError: (error: Error) => {
      setErrors([error.message ?? 'Failed to completed registrations']);
    }
  });

  const onSubmitFreeOrder = () => {
    if (!cartQuery.data) {
      return;
    }
    const carInfo: ProcessFreeOrderRequest = {
      cartId: cartQuery.data.id
    };
    processFreeOrderMutate(carInfo);
  };

  return (
    <RegisterLayout header={<GroupHeader />}>
      <BaseTransitionSlideLeft>
        <QueryContainer query={cartQuery} errorMessage="Failed to load the shopping cart.">
          {(shoppingCart) => {
            return (
              <UiStack flexGrow={1} spacing={8}>
                {/*<UiStack pb={4}>*/}
                {/*  <UiText variant={'h6'}>Shopping cart</UiText>*/}
                {/*</UiStack>*/}
                <InfoBox
                  title={'Shopping cart'}
                />
                <UiStack spacing={4}>
                  <RemindToAddTickets isGroup={true}/>
                  <BaseShoppingCart />
                </UiStack>
              </UiStack>
            );
          }}
        </QueryContainer>
      </BaseTransitionSlideLeft>
      <UiStack height={96} />
      <LayoutFooter isGroup>
        <UiHStack justifyContent={'space-between'} flexGrow={1}>
          {/*<UiButton*/}
          {/*  size={'lg'}*/}
          {/*  colorScheme={'primary'}*/}
          {/*  onClick={toPreviousStep}*/}
          {/*  variant={'ghost'}*/}
          {/*  fontSize={'lg'}*/}
          {/*  leftIcon={(*/}
          {/*    <UiIconCaretLeft color={'primary.800'} size={'xl'} weight={'bold'}/>*/}
          {/*  )}*/}
          {/*>*/}
          {/*  Previous*/}
          {/*</UiButton>*/}
          <BaseThemeButton
            theme={'gray'}
            onClick={toPreviousStep}
            leftIcon={(
              <UiIconCaretLeft color={'primary.800'} size={'lg'} weight={'bold'}/>
            )}
          >
            Prev
          </BaseThemeButton>

          {isCurrencyValueZero(cartQuery?.data?.totalAmount?.toString() ?? '') ? (
            // <UiButton px={8} size={'lg'} shadow={'base'} colorScheme={'primary'} onClick={onSubmitFreeOrder} isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0} isLoading={isProcessFreeOrderLoading}>
            //   Complete registration
            // </UiButton>
            // <UiButton
            //   size={'lg'}
            //   colorScheme={'primary'}
            //   onClick={onSubmitFreeOrder}
            //   variant={'ghost'}
            //   fontSize={'lg'}
            //   isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0}
            //   isLoading={isProcessFreeOrderLoading}
            //   rightIcon={(
            //     <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>
            //   )}
            // >
            //   Complete registration
            // </UiButton>
            <BaseThemeButton
              theme={'primary'}
              onClick={onSubmitFreeOrder}
              isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0}
              rightIcon={(
                <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
              )}
            >
              Next
            </BaseThemeButton>
          ) : (
            // <UiButton px={8} size={'lg'} shadow={'base'} colorScheme={'primary'} onClick={toNextStep} isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0}>
            //   Next
            // </UiButton>
            // <UiButton
            //   size={'lg'}
            //   colorScheme={'primary'}
            //   onClick={toNextStep}
            //   variant={'ghost'}
            //   fontSize={'lg'}
            //   isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0}
            //   rightIcon={(
            //     <UiIconCaretRight color={'primary.800'} size={'xl'} weight={'bold'}/>
            //   )}
            // >
            //   Next
            // </UiButton>
            <BaseThemeButton
              theme={'primary'}
              onClick={toNextStep}
              isDisabled={(cartQuery?.data?.cartItems?.length ?? 0) == 0}
              rightIcon={(
                <UiIconCaretRight color={'primary.800'} size={'lg'} weight={'bold'}/>
              )}
            >
              Next
            </BaseThemeButton>
          )}
        </UiHStack>
      </LayoutFooter>
    </RegisterLayout>
  );
};

export default ShoppingCart;
